import React from "react";
import iconUpload from "../../assets/icons/serviceOverview/IconDocumentUpload";
import { Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router";
import ContentBox from "../Box/ContentBox/ContentBox";
import { AbstractCase } from "../../types/Entities/AbstractCase";

type ServiceWorldSendMessageBoxProps = {
  product: AbstractCase;
};

export default function ServiceWorldSendMessageBox({ product }: ServiceWorldSendMessageBoxProps) {

  return (
    <ContentBox headline="Nachricht senden" icon={iconUpload} elevation={4} alignContent={"stretch"} loading={false}>
      <Stack spacing={2} sx={{
        alignItems: "center"
      }}>
        <Typography>Hier können Sie jederzeit direkt eine Frage stellen, weitere Details mitteilen oder uns Dokumente zusenden.</Typography>
        <Button fullWidth variant={"contained"} component={Link} to={`/servicewelt/nachrichten/neu?product=${product.name}&productId=${product.id}`}>
          Nachricht senden
        </Button>
      </Stack>
    </ContentBox>
  );
};
